import React, { MouseEventHandler } from 'react'
import { Link } from 'react-router-dom';

interface RedirectButtonProps {
    display: string;
    url: string;
    className?: string;
    onClick?: MouseEventHandler
    disabled?: boolean;
}

function RedirectButton ({ display, url, className, onClick, disabled = false }: RedirectButtonProps) {
    return (
        <Link to={url}>
            <button className={className} onClick={onClick} disabled={disabled}>{display} </button>
        </Link>
    )
}

export default RedirectButton